import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ForgotPasswordDataType } from '../../../models/auth/forgotPassword.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useForgotPassword = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [forgotPasswordError,
    //  setForgotPasswordError
  ] = useState(false);

  const onForgotPasswordError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(err?.response?.data?.message ?? 'Something went wrong');
  };

  const onPasswordForgotPassword = (callbackFn: () => void) => ({ data }: SuccessHttpResponse<any>) => {
    callbackFn();
  };

  const forgotPassword = (data: ForgotPasswordDataType, callbackFn: () => void) => {
    const url: HttpConfig = {
      url: `api/v1/auth/forgot-password?email=${data.email}`,
      method: 'get',
      // data,
    };

    request(url, onPasswordForgotPassword(callbackFn), setLoading, onForgotPasswordError);
  };
  return {
    loading,
    forgotPassword,
    forgotPasswordError
  };
};

export default useForgotPassword;
